import { passThroughAxios } from './passThrough.axios'

export default {
  email(reportName, params = {}) {
    return passThroughAxios.get(`reports/${reportName}/email`, { params })
  },
  download(reportName, params = {}) {
    return passThroughAxios.get(`reports/${reportName}/download`, {
      params,
      responseType: 'blob',
    })
  },
}
